@use '@/sass/variables';

.chip {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 2px variables.$spacing-small;
  font-size: variables.$font-size-8;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid;

  &.reserved {
    background: variables.$light-gray;
  }

  &.planned {
    background: variables.$washed-blue;
    border-color: variables.$blue;
    color: variables.$blue;
  }

  &.collected {
    background: variables.$washed-green;
    border-color: variables.$green;
    color: variables.$green;
  }
}
